const validatePost = (schema) => async (req, res, next) => {
  try {
    const fetch = await schema.validate(req.body, { abortEarly: false });
    return next();
  } catch (err) {
    return res.status(500).json({ type: err.name, message: err.message });
  }
};
const validateQuery = (schema) => async (req, res, next) => {
  try {
    await schema.validate({
      query: req.query,
    });
    return next();
  } catch (err) {
    return res.status(500).json({ type: err.name, message: err.message });
  }
};
const validateParams = (schema) => async (req, res, next) => {
  try {
    await schema.validate({
      params: req.params,
    });
    return next();
  } catch (err) {
    return res.status(500).json({ type: err.name, message: err.message });
  }
};

module.exports = {
  validatePost,
  validateParams,
  validateQuery,
};
